import React, { useCallback, useState } from "react";
import { BoxComponentProps } from "../FormLayout/FormLayout";
import { InputFormElement } from "../UIComponents/InputFormElement";
import SendSmsAgainButton from "../SendSmsAgainButton/SendSmsAgainButton";
import { useAppDispatch, useAppSelector } from "../../store";
import { CommonAsyncThunkAction } from "../../pages/PasswordForm/modes";
import { UserFormData } from "../../slices/userSlice";

interface AuthorizationCodeInputProps extends BoxComponentProps<{ authorizationCode: string }> {
  onResendAction: (formData: UserFormData) => CommonAsyncThunkAction;
}

export const AuthorizationCodeInput = (props: AuthorizationCodeInputProps) => {
  const {
    fieldsValue,
    onFieldValueChange,
    onFieldValueBlur,
    hasValidationError,
    getValidationMessagesTrKeys,
    onResendAction,
  } = props;
  const dispatch = useAppDispatch();
  const { formData } = useAppSelector((state) => state.user);
  const isAuthorizationCodeValid = !getValidationMessagesTrKeys("authorizationCode")?.some(
    (v) => v.trKey === "apiErrors.wrongAuthorizationCode"
  );
  const [isResendSmsLoaderVisible, setIsResendSmsLoaderVisible] = useState(false);
  const resendAuthorizationCode = useCallback(() => {
    if (isResendSmsLoaderVisible) return;
    dispatch(onResendAction(formData) as unknown as CommonAsyncThunkAction);
    setIsResendSmsLoaderVisible(true);
    setTimeout(() => setIsResendSmsLoaderVisible(false), 1000);
  }, [isResendSmsLoaderVisible, dispatch, formData]);

  return (
    <>
      <InputFormElement
        labelProps={{
          labelTrKey: "common.placeholders.authorizationCode",
        }}
        inputProps={{
          value: fieldsValue.authorizationCode,
          onChange: onFieldValueChange("authorizationCode"),
          onBlur: onFieldValueBlur("authorizationCode"),
          isInvalid: hasValidationError("authorizationCode"),
          inputType: "password",
          inputMode: "numeric",
          allowedSignsRegex: "^\\d*$",
          validationMessagesTrKeys: getValidationMessagesTrKeys("authorizationCode"),
        }}
      />
      {!!isAuthorizationCodeValid && <SendSmsAgainButton onClick={resendAuthorizationCode} />}
    </>
  );
};
